import { render } from "./GameAddData.vue?vue&type=template&id=53ca4d82"
import script from "./GameAddData.vue?vue&type=script&lang=js"
export * from "./GameAddData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__